import { render, staticRenderFns } from "./ProductOrders.vue?vue&type=template&id=5bc1de12&scoped=true"
import script from "./ProductOrders.vue?vue&type=script&lang=ts"
export * from "./ProductOrders.vue?vue&type=script&lang=ts"
import style0 from "./ProductOrders.vue?vue&type=style&index=0&id=5bc1de12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1de12",
  null
  
)

export default component.exports